var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { SalesRepDataActionType } from "../../../reduxStore/actions/actionTypes";
import store from "../../../reduxStore/store";
import { Typography } from "@mui/material";
//Language Translation
import { useTranslation } from "react-i18next";
import { EDIT_ORDER_FLAG, IS_BILLING_ADDRESS, IS_SHIPPING_ADDRESS, REDIRECT_TAB_FLAG } from "../../Constant";
import { CommonMethods } from "../../MyCompany/CommonMethods";
import Tabs from "../../HomeAndNavigation/Tabs";
import { GetCompanyLocationPricelist, getB2BCompaniesAction, getB2BCompanyByIdAction } from "../../../reduxStore/actions/salesRepDataAction";
import { SharedFunctions } from "../../SharedFunctions";
export function B2bCustomerDetailsBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var _r = CommonMethods(), mapAddressOfselectedCompanyInCreateOrder = _r.mapAddressOfselectedCompanyInCreateOrder, renderAddress = _r.renderAddress;
    var getCountriesList = SharedFunctions().getCountriesList;
    var _s = useState({}), selectedCompanyAddresses = _s[0], setSelectedCompanyAddresses = _s[1];
    var _t = useState({
        companyId: "",
        companyName: "",
        locationMainContactId: "",
        locationId: "",
        locationName: "",
        customerEmail: "",
        customerId: "",
        customerName: "",
        ShippingAddress: {},
        BillingAddress: {},
    }), companyDetails = _t[0], setCompanyDetails = _t[1];
    var _u = useState(), customerDetailsForSelectedCompany = _u[0], setCustomerDetailsForSelectedCompany = _u[1];
    var _v = useState("isShippingAddress"), addressType = _v[0], setAddressType = _v[1];
    var _w = useState(false), addressModal = _w[0], setAddressModal = _w[1];
    // Companies popup state — all data comes from data=56 (GetB2BCompanyDetails)
    var _x = useState(false), companiesPopupOpen = _x[0], setCompaniesPopupOpen = _x[1];
    var _y = useState(false), isCompanyFetching = _y[0], setIsCompanyFetching = _y[1];
    var _z = useState(false), isSearching = _z[0], setIsSearching = _z[1];
    var _0 = useState(""), currentSearchTerm = _0[0], setCurrentSearchTerm = _0[1];
    var _1 = useState([]), localCompanies = _1[0], setLocalCompanies = _1[1];
    var _2 = useState({
        endCursor: "",
        startCursor: "",
        hasNext: false,
        hasPrevious: false,
    }), paginationState = _2[0], setPaginationState = _2[1];
    // Use useSelector to make reduxEditOrderDataObj reactive to Redux changes
    var reduxEditOrderDataObj = useSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {}; });
    var customerDetailsCreateInvoice = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.customerDetailsCreateInvoice;
    // Check if any products from cart are missing from price list (for banner display)
    var hasProductsMissingFromPriceList = (_b = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.hasProductsMissingFromPriceList) !== null && _b !== void 0 ? _b : false;
    // Debug: Log redux edit order data changes
    useEffect(function () {
        var _a;
        var isEditOrder = (reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent) === EDIT_ORDER_FLAG;
        var b2bCompany = (_a = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _a === void 0 ? void 0 : _a.b2bCompany;
        var isB2BEditOrder = !!((b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.id) && (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.location_id)); // Ensure boolean return
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent, (_d = (_c = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _c === void 0 ? void 0 : _c.b2bCompany) === null || _d === void 0 ? void 0 : _d.id, (_f = (_e = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _e === void 0 ? void 0 : _e.b2bCompany) === null || _f === void 0 ? void 0 : _f.location_id]);
    var tabsArray = (_g = Tabs()) === null || _g === void 0 ? void 0 : _g.filter(function (item) {
        return item === null || item === void 0 ? void 0 : item.isActive;
    });
    var _3 = useState(false), orderCreatedSuccesfullyFlag = _3[0], setOrderCreatedSuccesfullyFlag = _3[1];
    // Point 4: Check if it's a B2B edit order (not just any edit order) - computed early for use in manageMenuItems
    var b2bCompany = (_h = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _h === void 0 ? void 0 : _h.b2bCompany;
    var isB2BEditOrder = !!((b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.id) && (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.location_id)); // Ensure boolean return
    var isEditOrder = (reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent) === EDIT_ORDER_FLAG;
    // Filter out "Remove_Company" option when editing B2B draft order
    var manageMenuItems = __spreadArray([
        { label: t("Edit_Shipping_Address"), action: "Edit_shipping_address" },
        { label: t("Edit_Billing_Address"), action: "Edit_billing_address" }
    ], (isEditOrder && isB2BEditOrder ? [] : [{ label: t("Remove_Company"), action: "Remove_company", sx: { color: "#C70A24" } }]), true);
    var _4 = useState({}), selectedLocationPaymentTerms = _4[0], setSelectedLocationPaymentTerms = _4[1];
    var selectFeatures = (_k = (_j = store.getState().salesRepData) === null || _j === void 0 ? void 0 : _j.baseData) === null || _k === void 0 ? void 0 : _k.select;
    // Open close popup
    var handleOpenSelectCustomerPopup = function (event, company) {
        var _a;
        try {
            if (event) {
                setSelectedCompanyAddresses(company === null || company === void 0 ? void 0 : company.assignedLocations);
                setCompanyDetails(__assign(__assign({}, companyDetails), { companyName: company === null || company === void 0 ? void 0 : company.companyName, companyId: company === null || company === void 0 ? void 0 : company.companyId, locationMainContactId: (_a = company === null || company === void 0 ? void 0 : company.locationMainContactId) !== null && _a !== void 0 ? _a : "" }));
            }
            else {
                setCompanyDetails(__assign(__assign({}, companyDetails), { companyName: "", locationName: "", locationId: "", companyId: "", locationMainContactId: "", customerEmail: "", customerName: "", customerId: "" }));
            }
        }
        catch (error) {
            return null;
        }
    };
    var removeSelectedCustomer = function () {
        try {
            var action = {
                payload: "",
                type: SalesRepDataActionType.CUSTOMER_DETAILS_CREATE_INVOICE,
            };
            dispatch(action);
        }
        catch (error) {
            return;
        }
    };
    // Helpers — all company data comes exclusively from data=56 (GetB2BCompanyDetails)
    var updateLocalCompanyState = function (data) {
        var _a, _b, _c, _d, _e;
        setLocalCompanies((_a = data === null || data === void 0 ? void 0 : data.companies) !== null && _a !== void 0 ? _a : []);
        setPaginationState({
            endCursor: (_b = data === null || data === void 0 ? void 0 : data.endCursor) !== null && _b !== void 0 ? _b : "",
            startCursor: (_c = data === null || data === void 0 ? void 0 : data.startCursor) !== null && _c !== void 0 ? _c : "",
            hasNext: (_d = data === null || data === void 0 ? void 0 : data.hasNext) !== null && _d !== void 0 ? _d : false,
            hasPrevious: (_e = data === null || data === void 0 ? void 0 : data.hasPrevious) !== null && _e !== void 0 ? _e : false,
        });
    };
    var fetchB2BCompanies = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, getB2BCompaniesAction({
                        batchSize: 50,
                        searchQuery: (_a = params.searchQuery) !== null && _a !== void 0 ? _a : "",
                        isNextPage: (_b = params.isNextPage) !== null && _b !== void 0 ? _b : true,
                        endCursor: (_c = params.endCursor) !== null && _c !== void 0 ? _c : "",
                        startCursor: (_d = params.startCursor) !== null && _d !== void 0 ? _d : "",
                        isShowAllCustomer: (_e = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.showAllCustomer) !== null && _e !== void 0 ? _e : false,
                        isSaveToStore: (_f = params.isSaveToStore) !== null && _f !== void 0 ? _f : false,
                    })(dispatch)];
                case 1:
                    response = _g.sent();
                    if (response) {
                        updateLocalCompanyState(response);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOpenCompaniesPopup = function () { return __awaiter(_this, void 0, void 0, function () {
        var cachedCompanies;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setCompaniesPopupOpen(true);
                    setIsCompanyFetching(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 5, 6]);
                    cachedCompanies = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.b2bCompaniesData;
                    if (!((cachedCompanies === null || cachedCompanies === void 0 ? void 0 : cachedCompanies.companies) && cachedCompanies.companies.length > 0)) return [3 /*break*/, 2];
                    updateLocalCompanyState(cachedCompanies);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchB2BCompanies({ isNextPage: true, endCursor: "", startCursor: "", isSaveToStore: true })];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    setIsCompanyFetching(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseCompaniesPopup = function () {
        setCompaniesPopupOpen(false);
        setCurrentSearchTerm("");
        setLocalCompanies([]);
        setPaginationState({ endCursor: "", startCursor: "", hasNext: false, hasPrevious: false });
    };
    var handleSearchCompanies = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsSearching(true);
                    setCurrentSearchTerm((_a = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim()) !== null && _a !== void 0 ? _a : "");
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, fetchB2BCompanies({ searchQuery: (_b = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim()) !== null && _b !== void 0 ? _b : "", isNextPage: true, endCursor: "", startCursor: "", isSaveToStore: false })];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSearching(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handlePageChangeCompanies = function (direction) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSearching(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, fetchB2BCompanies({
                            searchQuery: currentSearchTerm,
                            isNextPage: direction === "next",
                            endCursor: paginationState.endCursor,
                            startCursor: paginationState.startCursor,
                            isSaveToStore: false,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSearching(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCompanySelectFromPopup = function (company) {
        handleOpenSelectCustomerPopup(true, company);
        handleCloseCompaniesPopup();
    };
    var EmptyAllFieldsOnSuccess = function () {
        setSelectedCompanyAddresses({});
        setCompanyDetails({
            companyName: "",
            locationName: "",
            locationId: "",
            companyId: "",
            locationMainContactId: "",
            customerEmail: "",
            customerName: "",
            customerId: "",
            ShippingAddress: {},
            BillingAddress: {},
        });
        setCustomerDetailsForSelectedCompany({});
    };
    var handleNewCompanyModal = function () {
        if ((reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent) !== EDIT_ORDER_FLAG) {
            handleReduxUpdate({}, SalesRepDataActionType.EDIT_DRAFT_ORDER);
        }
        var companyTabIndex = tabsArray === null || tabsArray === void 0 ? void 0 : tabsArray.findIndex(function (tab) { return (tab === null || tab === void 0 ? void 0 : tab.label) === "My Company"; });
        if (companyTabIndex !== -1) {
            handleReduxUpdate({ activeTabIndex: companyTabIndex, actionEvent: REDIRECT_TAB_FLAG }, SalesRepDataActionType.ACTIVE_TAB);
        }
    };
    var handleReduxUpdate = function (payloadData, actionType) {
        var updateReduxState = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(updateReduxState);
    };
    var handleAddressModal = function () {
        setAddressModal(!addressModal);
    };
    var handleMenuAction = function (action) {
        var _a;
        var actionsMap = {
            Remove_company: function () {
                removeSelectedCustomer();
                EmptyAllFieldsOnSuccess();
            },
            Edit_shipping_address: function () {
                setAddressType("isShippingAddress");
                setAddressModal(!addressModal);
            },
            Edit_billing_address: function () {
                setAddressType("isBillingAddress");
                setAddressModal(!addressModal);
            },
        };
        // Execute the action if it exists
        (_a = actionsMap[action]) === null || _a === void 0 ? void 0 : _a.call(actionsMap);
    };
    // handle location and customer change
    var handleSelectChange = function (e) {
        var _a, _b, _c, _d, _e, _f;
        try {
            var _g = e.target, value_1 = _g.value, name_1 = _g.name;
            var selectedCompanyDetails = selectedCompanyAddresses === null || selectedCompanyAddresses === void 0 ? void 0 : selectedCompanyAddresses.find(function (company) { return (company === null || company === void 0 ? void 0 : company.locationId) === value_1; });
            if (name_1 === "locationAddress" && selectedCompanyDetails !== undefined) {
                setCompanyDetails(__assign(__assign({}, companyDetails), { locationId: value_1, locationName: (_a = selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.locationName) !== null && _a !== void 0 ? _a : "", ShippingAddress: (_b = mapAddressOfselectedCompanyInCreateOrder(selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.shippingAddress)) !== null && _b !== void 0 ? _b : {}, BillingAddress: (_c = mapAddressOfselectedCompanyInCreateOrder(selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.billingAddress)) !== null && _c !== void 0 ? _c : {}, customerId: "" }));
                setCustomerDetailsForSelectedCompany(selectedCompanyDetails === null || selectedCompanyDetails === void 0 ? void 0 : selectedCompanyDetails.customerDetails);
            }
            else {
                var selectedCustomerDetails = customerDetailsForSelectedCompany === null || customerDetailsForSelectedCompany === void 0 ? void 0 : customerDetailsForSelectedCompany.find(function (customer) { return (customer === null || customer === void 0 ? void 0 : customer.customerId) === value_1; });
                var updatedCompanyDetails = __assign(__assign({}, companyDetails), { customerId: value_1, customerName: "".concat((_d = selectedCustomerDetails === null || selectedCustomerDetails === void 0 ? void 0 : selectedCustomerDetails.customerFirstName) !== null && _d !== void 0 ? _d : "", " ").concat((_e = selectedCustomerDetails === null || selectedCustomerDetails === void 0 ? void 0 : selectedCustomerDetails.customerLastName) !== null && _e !== void 0 ? _e : "").trim(), customerEmail: (_f = selectedCustomerDetails === null || selectedCustomerDetails === void 0 ? void 0 : selectedCustomerDetails.customerEmail) !== null && _f !== void 0 ? _f : "" });
                setCompanyDetails(updatedCompanyDetails);
                saveDetailsFetchCatalog(updatedCompanyDetails); // pass the updated object
            }
            setSelectedLocationPaymentTerms(selectedCompanyDetails);
        }
        catch (error) {
            return;
        }
    };
    var saveAddressData = function (type) {
        if (type === IS_SHIPPING_ADDRESS) {
            var updatedCompanyDetails = __assign(__assign({}, companyDetails), { ShippingAddress: companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.ShippingAddress });
            saveDetailsFetchCatalog(updatedCompanyDetails);
        }
        else {
            var updatedCompanyDetails = __assign(__assign({}, companyDetails), { BillingAddress: companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.BillingAddress });
            saveDetailsFetchCatalog(updatedCompanyDetails);
        }
    };
    var saveDetailsFetchCatalog = function (updatedCompanyDetails) { return __awaiter(_this, void 0, void 0, function () {
        var action, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = {
                        payload: updatedCompanyDetails,
                        type: SalesRepDataActionType.CUSTOMER_DETAILS_CREATE_INVOICE,
                    };
                    dispatch(action);
                    if (!(updatedCompanyDetails === null || updatedCompanyDetails === void 0 ? void 0 : updatedCompanyDetails.locationId)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(GetCompanyLocationPricelist(updatedCompanyDetails.locationId, "", false, false))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error fetching catalog:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getCustomerAddressData = function (addressType) {
        if (addressType === IS_SHIPPING_ADDRESS) {
            return renderAddress(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.ShippingAddress);
        }
        else if (addressType === IS_BILLING_ADDRESS) {
            return renderAddress(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.BillingAddress);
        }
        return (_jsx(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: "No Address Found" })));
    };
    // Auto-populate B2B company details for edit mode
    useEffect(function () {
        var _a, _b, _c, _d;
        var isEditOrder = (reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent) === EDIT_ORDER_FLAG;
        var b2bCompany = (_a = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _a === void 0 ? void 0 : _a.b2bCompany;
        // Check if we're on the B2B tab
        // Tab indices: 0=Dashboard, 1=CreateOrder, 2=B2B (in filtered active tabs array)
        var activeTab = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.activeTab;
        var B2B_ORDER_TAB_INDEX = 2;
        // Calculate B2B tab index in filtered active tabs array
        var activeTabsBeforeB2B = 0;
        var selectFeatures = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.baseData) === null || _d === void 0 ? void 0 : _d.select;
        // Dashboard (index 0) is always active
        activeTabsBeforeB2B++;
        // Create Order tab (index 1) - check if active
        if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateInvoice) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateOrder)) {
            activeTabsBeforeB2B++;
        }
        // B2B tab (index 2) is at position activeTabsBeforeB2B in the filtered array
        var b2BTabIndexInFilteredArray = activeTabsBeforeB2B;
        var isB2BTabActive = (activeTab === null || activeTab === void 0 ? void 0 : activeTab.activeTabIndex) === b2BTabIndexInFilteredArray;
        var hydrateEditModeB2BDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var draftOrderCustomer, company, companyByIdResponse, exactCompanies, location_1, locationIdForSelect, matchingCustomer, customerIdForSelect, customerByEmail, draftShippingAddress, draftBillingAddress, mapDraftOrderAddress, shippingAddressToMap, billingAddressToMap, updatedCompanyDetails;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        // Only process if it's edit mode AND b2bCompany has valid values
                        // Also check if customerDetailsCreateInvoice is empty (not already set) to avoid overwriting
                        // AND ensure we're on the B2B tab (to prevent patching when on wrong tab)
                        if (!(isEditOrder && b2bCompany && b2bCompany.id && b2bCompany.location_id && !(customerDetailsCreateInvoice === null || customerDetailsCreateInvoice === void 0 ? void 0 : customerDetailsCreateInvoice.companyId) && isB2BTabActive)) {
                            return [2 /*return*/];
                        }
                        draftOrderCustomer = reduxEditOrderDataObj.draftOrderObj.customer;
                        company = null;
                        return [4 /*yield*/, getB2BCompanyByIdAction({
                                companyId: String((_a = b2bCompany.id) !== null && _a !== void 0 ? _a : ""),
                            })(dispatch)];
                    case 1:
                        companyByIdResponse = _l.sent();
                        exactCompanies = (_b = companyByIdResponse === null || companyByIdResponse === void 0 ? void 0 : companyByIdResponse.companies) !== null && _b !== void 0 ? _b : [];
                        if (Array.isArray(exactCompanies) && exactCompanies.length > 0) {
                            company = exactCompanies[0];
                        }
                        if (company) {
                            setSelectedCompanyAddresses((company === null || company === void 0 ? void 0 : company.assignedLocations) || []);
                            location_1 = (_c = company === null || company === void 0 ? void 0 : company.assignedLocations) === null || _c === void 0 ? void 0 : _c.find(function (loc) {
                                var locationId = String((loc === null || loc === void 0 ? void 0 : loc.locationId) || "");
                                // Extract numeric ID from locationId if it's in GraphQL format
                                var locationNumericId = locationId.includes("gid://shopify/CompanyLocation/")
                                    ? locationId.split("gid://shopify/CompanyLocation/")[1]
                                    : locationId;
                                return locationNumericId === b2bCompany.location_id;
                            });
                            if (location_1) {
                                locationIdForSelect = (location_1 === null || location_1 === void 0 ? void 0 : location_1.locationId) || b2bCompany.location_id;
                                matchingCustomer = (_d = location_1 === null || location_1 === void 0 ? void 0 : location_1.customerDetails) === null || _d === void 0 ? void 0 : _d.find(function (cust) {
                                    var customerId = String((cust === null || cust === void 0 ? void 0 : cust.customerId) || "");
                                    var draftCustomerId = String((draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.id) || "");
                                    return customerId === draftCustomerId;
                                });
                                customerIdForSelect = matchingCustomer === null || matchingCustomer === void 0 ? void 0 : matchingCustomer.customerId;
                                if (!customerIdForSelect && (draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.email)) {
                                    customerByEmail = (_e = location_1 === null || location_1 === void 0 ? void 0 : location_1.customerDetails) === null || _e === void 0 ? void 0 : _e.find(function (cust) {
                                        return String((cust === null || cust === void 0 ? void 0 : cust.customerEmail) || "").toLowerCase() === String((draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.email) || "").toLowerCase();
                                    });
                                    customerIdForSelect = customerByEmail === null || customerByEmail === void 0 ? void 0 : customerByEmail.customerId;
                                }
                                // Final fallback to draft order customer ID
                                if (!customerIdForSelect && (draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.id)) {
                                    customerIdForSelect = draftOrderCustomer.id.toString();
                                }
                                draftShippingAddress = (_f = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _f === void 0 ? void 0 : _f.shipping_Address;
                                draftBillingAddress = (_g = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _g === void 0 ? void 0 : _g.billing_address;
                                mapDraftOrderAddress = function (draftAddress) {
                                    if (!draftAddress || (!draftAddress.address1 && !draftAddress.first_name)) {
                                        return null;
                                    }
                                    // Draft order format: { first_name, last_name, address1, address2, city, province, zip, country, phone, company }
                                    // Location format expected by mapAddressOfselectedCompanyInCreateOrder: { firstName, lastName, address1, address2, city, province, zip, country, phone, companyName }
                                    // Convert country name to country code (e.g., "INDIA" -> "IN")
                                    var countryName = draftAddress.country || "";
                                    var countryCode = "";
                                    if (countryName) {
                                        var countryList = getCountriesList() || [];
                                        var matchedCountry = countryList.find(function (c) { var _a; return ((_a = c === null || c === void 0 ? void 0 : c.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === countryName.toLowerCase(); });
                                        countryCode = (matchedCountry === null || matchedCountry === void 0 ? void 0 : matchedCountry.code) || "";
                                    }
                                    return {
                                        firstName: draftAddress.first_name || "",
                                        lastName: draftAddress.last_name || "",
                                        address1: draftAddress.address1 || "",
                                        address2: draftAddress.address2 || "",
                                        city: draftAddress.city || "",
                                        province: draftAddress.province || "",
                                        zip: draftAddress.zip || "",
                                        country: countryName,
                                        phone: draftAddress.phone || "",
                                        companyName: draftAddress.company || "",
                                        countryCode: countryCode, // Converted from country name to country code
                                    };
                                };
                                shippingAddressToMap = draftShippingAddress && (draftShippingAddress.address1 || draftShippingAddress.first_name)
                                    ? mapDraftOrderAddress(draftShippingAddress)
                                    : location_1 === null || location_1 === void 0 ? void 0 : location_1.shippingAddress;
                                billingAddressToMap = draftBillingAddress && (draftBillingAddress.address1 || draftBillingAddress.first_name)
                                    ? mapDraftOrderAddress(draftBillingAddress)
                                    : location_1 === null || location_1 === void 0 ? void 0 : location_1.billingAddress;
                                updatedCompanyDetails = {
                                    companyId: b2bCompany.id,
                                    companyName: b2bCompany.name || "",
                                    locationMainContactId: (_h = company === null || company === void 0 ? void 0 : company.locationMainContactId) !== null && _h !== void 0 ? _h : "",
                                    locationId: locationIdForSelect,
                                    locationName: b2bCompany.location_name || (location_1 === null || location_1 === void 0 ? void 0 : location_1.locationName) || "",
                                    customerId: customerIdForSelect || "",
                                    customerName: matchingCustomer
                                        ? "".concat((matchingCustomer === null || matchingCustomer === void 0 ? void 0 : matchingCustomer.customerFirstName) || "", " ").concat((matchingCustomer === null || matchingCustomer === void 0 ? void 0 : matchingCustomer.customerLastName) || "").trim()
                                        : "".concat((draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.first_name) || "", " ").concat((draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.last_name) || "").trim(),
                                    customerEmail: (matchingCustomer === null || matchingCustomer === void 0 ? void 0 : matchingCustomer.customerEmail) || (draftOrderCustomer === null || draftOrderCustomer === void 0 ? void 0 : draftOrderCustomer.email) || "",
                                    ShippingAddress: (_j = mapAddressOfselectedCompanyInCreateOrder(shippingAddressToMap)) !== null && _j !== void 0 ? _j : {},
                                    BillingAddress: (_k = mapAddressOfselectedCompanyInCreateOrder(billingAddressToMap)) !== null && _k !== void 0 ? _k : {},
                                };
                                setCompanyDetails(updatedCompanyDetails);
                                setCustomerDetailsForSelectedCompany(location_1 === null || location_1 === void 0 ? void 0 : location_1.customerDetails);
                                setSelectedLocationPaymentTerms(location_1);
                                // Save to Redux and fetch catalog
                                saveDetailsFetchCatalog(updatedCompanyDetails);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        hydrateEditModeB2BDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent, (_m = (_l = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _l === void 0 ? void 0 : _l.b2bCompany) === null || _m === void 0 ? void 0 : _m.id, (_p = (_o = reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.draftOrderObj) === null || _o === void 0 ? void 0 : _o.b2bCompany) === null || _p === void 0 ? void 0 : _p.location_id, customerDetailsCreateInvoice]);
    // Point 1: Clear local B2B component state when switching away from B2B tab
    useEffect(function () {
        var _a, _b, _c;
        var activeTab = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.activeTab;
        // Calculate B2B tab index in filtered active tabs array
        var activeTabsBeforeB2B = 0;
        var selectFeatures = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.baseData) === null || _c === void 0 ? void 0 : _c.select;
        // Dashboard (index 0) is always active
        activeTabsBeforeB2B++;
        // Create Order tab (index 1) - check if active
        if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateInvoice) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateOrder)) {
            activeTabsBeforeB2B++;
        }
        // B2B tab (index 2) is at position activeTabsBeforeB2B in the filtered array
        var b2BTabIndexInFilteredArray = activeTabsBeforeB2B;
        var isB2BTabActive = (activeTab === null || activeTab === void 0 ? void 0 : activeTab.activeTabIndex) === b2BTabIndexInFilteredArray;
        // If we're not on B2B tab and customerDetailsCreateInvoice is cleared (meaning we switched away), clear local state
        if (!isB2BTabActive && !(customerDetailsCreateInvoice === null || customerDetailsCreateInvoice === void 0 ? void 0 : customerDetailsCreateInvoice.companyId)) {
            EmptyAllFieldsOnSuccess();
            setSelectedLocationPaymentTerms({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerDetailsCreateInvoice]);
    var companyHeaderNames = [
        { id: "CompanyName", label: t("Company_Details"), inlineCSS: { width: "60%" } },
        { id: "Locations", label: t("b2b_select_location"), inlineCSS: { width: "40%" } },
    ];
    return {
        t: t,
        handleOpenSelectCustomerPopup: handleOpenSelectCustomerPopup,
        handleSelectChange: handleSelectChange,
        companyDetails: companyDetails,
        selectedCompanyAddresses: selectedCompanyAddresses,
        customerDetailsForSelectedCompany: customerDetailsForSelectedCompany,
        manageMenuItems: manageMenuItems,
        handleMenuAction: handleMenuAction,
        getCustomerAddressData: getCustomerAddressData,
        handleNewCompanyModal: handleNewCompanyModal,
        handleAddressModal: handleAddressModal,
        addressModal: addressModal,
        addressType: addressType,
        setCompanyDetails: setCompanyDetails,
        saveAddressData: saveAddressData,
        orderCreatedSuccesfullyFlag: orderCreatedSuccesfullyFlag,
        setOrderCreatedSuccesfullyFlag: setOrderCreatedSuccesfullyFlag,
        EmptyAllFieldsOnSuccess: EmptyAllFieldsOnSuccess,
        selectedLocationPaymentTerms: selectedLocationPaymentTerms,
        isEditOrder: isEditOrder,
        isB2BEditOrder: isB2BEditOrder,
        hasProductsMissingFromPriceList: hasProductsMissingFromPriceList,
        // Companies popup
        companiesPopupOpen: companiesPopupOpen,
        handleOpenCompaniesPopup: handleOpenCompaniesPopup,
        handleCloseCompaniesPopup: handleCloseCompaniesPopup,
        handleSearchCompanies: handleSearchCompanies,
        handlePageChangeCompanies: handlePageChangeCompanies,
        handleCompanySelectFromPopup: handleCompanySelectFromPopup,
        localCompanies: localCompanies,
        paginationState: paginationState,
        isSearching: isSearching,
        isCompanyFetching: isCompanyFetching,
        currentSearchTerm: currentSearchTerm,
        companyHeaderNames: companyHeaderNames,
        totalCompanyCount: (_q = localCompanies === null || localCompanies === void 0 ? void 0 : localCompanies.length) !== null && _q !== void 0 ? _q : 0,
    };
}
export function cssConstants() {
    var ST_B2BHeading = {
        display: "flex",
        justifyContent: "space-between",
    };
    var ST_CI_textfield_BackgrounColor = {
        backgroundColor: "white",
    };
    return {
        ST_B2BHeading: ST_B2BHeading,
        ST_CI_textfield_BackgrounColor: ST_CI_textfield_BackgrounColor,
    };
}
